<template>
  <div class="trainingRecord">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="序号" align="center" width="50" fixed>
        <template slot-scope="scope">
          <span>{{ (paging.page - 1) * paging.limit + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="测试时间" align="center" width="180">
        <template slot-scope="scope">
          <span
            >{{
              scope.row.opening_class_start_time
                | dateformat("YYYY-MM-DD HH:mm:ss")
            }}至{{
              scope.row.opening_class_end_time
                | dateformat("YYYY-MM-DD HH:mm:ss")
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="等级" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.grade | grade }}</span>
        </template>
      </el-table-column>
      <el-table-column label="培训班名称" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.coachName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报名类型" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.signup_type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报名" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.payment_status == 1">待审核</span>
          <span v-if="scope.row.payment_status == 3">审核通过</span>
          <span v-if="scope.row.payment_status == 9">审核中</span>
        </template>
      </el-table-column>
      <el-table-column label="费用" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.order_price }}元</span>
        </template>
      </el-table-column>
      <el-table-column label="缴费状态" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.payment_status | status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易类型" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.payment_type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="成绩" align="center" width="100">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.payment_status == 9"
            :underline="false"
            type="info"
            >已关闭
          </el-link>
          <el-link
            v-else
            :underline="false"
            @click="view(scope.row)"
            :disabled="scope.row.performance_review == 0"
            :type="
              scope.row.performance_review == 0
                ? 'info'
                : scope.row.performance_review == 1
                ? 'success'
                : scope.row.performance_review == 2
                ? 'danger'
                : ''
            "
          >
            {{ scope.row.performance_review | review }}
            <i class="el-icon-search"></i>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <!--          <el-link
            :underline="false"
            @click="goPay(scope.row.order_sn)"
            type="primary"
            v-if="scope.row.payment_status == 1"
            >去支付
          </el-link>-->
          <el-link
            :underline="false"
            type="warning"
            @click="InvoiceVisible = true"
            v-if="scope.row.payment_status == 1"
            >查看发票信息
          </el-link>
        </template>
        <!-- @click="goPay(scope.row)" -->
      </el-table-column>
    </el-table>
    <el-dialog title="查看成绩" :visible.sync="dialogTableVisible">
      <el-table :data="gradeData">
        <el-table-column label="序号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="content"
          label="考核内容"
          align="center"
        ></el-table-column>
        <el-table-column
          property="score"
          label="成绩"
          align="center"
        ></el-table-column>

        <!--  <el-table-column property="is_qualified" label="是否合格" align="center"></el-table-column>   -->
      </el-table>
    </el-dialog>
    <div class="pagination" style="margin-top: 55px; text-align: center">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount > 8"
      ></el-pagination>
    </div>
    <makeOutInvoice
      :dialogVisible="InvoiceVisible"
      @cancel="cancelData"
      @default="defaultData"
    />

    <el-dialog
      title="二维码支付"
      :visible.sync="paydialog"
      :width="screenWidth > 768 ? '40%' : '90%'"
      center
      :close-on-click-modal="false"
    >
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img" />
        <div>仅支持微信扫码支付</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetUserInvoiceInfo,
  GetDicData,
  GDCloudPayV2,
  GetPaymentStatus,
} from "@/api/admin/common.js";
import {
  GetCoachTrainEnrolment,
  GetScoreToViewList,
} from "@/api/admin/appraiser.js";
import makeOutInvoice from "@/views/admin/components/makeOutInvoice.vue";
import { mapGetters } from "vuex";
//声明一个全局变量
let that;
export default {
  components: {
    makeOutInvoice,
  },
  computed: {
    ...mapGetters(["screenWidth"]),
  },
  data() {
    return {
      formData: {},
      payview: false,
      paydialog: false,
      sn: null,
      tableData: [],
      gradeData: [],
      totalCount: 0,
      paging: {
        limit: 8,
        page: 1,
      },
      time: null,
      dicData: {
        payment_status: "payment_status",
        appraiser_grade: "appraiser_grade",
      },
      payment_status: [],
      appraiser_grade: [],
      dialogTableVisible: false,
      InvoiceVisible: false,
      custname: "",
      radio: "1",
      imgPath: window.apiObj.apiUrl,
      formInvoice: {},
    };
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
  created() {
    this.getList();
    this.dictionaryData();
    this.intervalPay();
    this.time = setInterval(() => {
      this.intervalPay();
    }, 10000);
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    intervalPay() {
      if (this.payview) {
        if (this.sn != null) {
          GetPaymentStatus({ order_sn: this.sn }).then((data) => {
            if (data.data.result.orderStatus == 3) {
              this.$message({
                message: "支付完成",
                type: "success",
              });
              this.paydialog = false;
              this.payview = false;
              this.sn = null;
            }
          });
        }
      }
    },
    getList() {
      GetCoachTrainEnrolment(Object.assign(this.paging)).then((data) => {
        let list = data.data.result;
        this.totalCount = list.totalCount;
        if (list.items.length > 0) {
          this.tableData = list.items;
        }
      });
    },
    dictionaryData() {
      GetDicData({ classCode: this.dicData.payment_status }).then((data) => {
        let list = data.data.result;
        if (list.length > 0) {
          this.payment_status = list;
        }
      });
      GetDicData({ classCode: this.dicData.appraiser_grade }).then((data) => {
        let list = data.data.result;
        if (list.length > 0) {
          this.appraiser_grade = list;
        }
      });
    },
    view(item) {
      this.dialogTableVisible = true;
      this.gradeData = [];
      GetScoreToViewList({
        tc_id: item.tc_id,
      }).then((data) => {
        let list = data.data.result;
        if (list.items[0].scores.length > 0) {
          this.gradeData = list.items[0].scores;
        }
      });
    },
    handleCurrentChange(page) {
      this.paging.page = page;
      this.getList();
    },
    goPay(e) {
      // this.$message({
      //   message: "订单确认中",
      //   type: "success"
      // });
      GDCloudPayV2({ order_sn: e }).then((data) => {
        this.sn = e;
        if (data.data.result.isSuccess) {
          this.paydialog = true;
          this.payview = true;
          this.formData.img =
            "http://218.58.55.130:8765" + data.data.result.payCode;
          this.formData.img = this.imgPath + data.data.result.payCode;
        } else {
          this.$message({
            message: data.data.result.errorMsg,
            type: "error",
          });
        }
        // this.payview=true;
        // this.paydialog = true;
      });
    },
    defaultData() {
      GetUserInvoiceInfo({}).then((data) => {
        var list = data.data.result;
        if (list.invoiceInfo) {
          if (list.invoiceInfo.custtype == "01") {
            this.radio = "2";
            this.formInvoice = list.invoiceInfo;
          } else {
            this.radio = "1";
          }
        }
      });
    },
    cancelData() {
      this.InvoiceVisible = false;
    },
  },
  filters: {
    status: (data) => {
      for (var i in that.payment_status) {
        if (that.payment_status[i].value == data) {
          return that.payment_status[i].label;
        }
      }
    },
    grade: (data) => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    },
    review: (data) => {
      switch (data) {
        case 0:
          return "待审核";
        case 1:
          return "合格";
        case 2:
          return "不合格";
      }
    },
  },
};
</script>

<style lang="less">
.trainingRecord {
  @media screen and (max-width: 500px) {
    .el-dialog {
      width: 90%;
    }
  }
}

.paystyle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  color: #ea0000;
}
</style>
